import React from 'react';
import ShortcutModal from "./ShortcutModal";

const Tour = () => {
    return (
        <div>
            <video width="320" height="240" controls>
                <source src="movie.mp4" type="video/mp4" />
            </video>
            <ShortcutModal />
        </div>
    );
};

export { Tour };